import React from "react";
import { useQuery } from "@apollo/client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faCaretRight } from "@fortawesome/free-solid-svg-icons";

import DtsReactTable from "../../reuseableComponents/dtsReactTable/DtsReactTable";
import { GET_SOURCES } from "../../../queries/archiveQrys/InventoryReportQueries";
import {
  waterSystemStatus,
  activityType,
  sourceType,
  waterType
} from "../../../utilities/constants/WaterSystemConstants";
import { convertTimeStampToDate } from "../../../utilities/commonFunctions/timeConversionFunctions";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import ErrorHandler from "../../reuseableComponents/ErrorHandler";

const SourcesTable = ({ systemId }) => {
  const columns = [
    {
      Header: () => null,
      id: "expander",
      width: 30,
      Cell: ({ row }) => (
        <span {...row.getToggleRowExpandedProps()}>
          {row.isExpanded ? (
            <FontAwesomeIcon className='font-icon' icon={faCaretDown} cypressid={row.original.sourceId + "_srcd"} />
          ) : (
            <FontAwesomeIcon className='font-icon' icon={faCaretRight} cypressid={row.original.sourceId + "_srcr"} />
          )}
        </span>
      )
    },
    {
      Header: "ID",
      accessor: "sourceId",

      width: 75
    },
    {
      Header: "Source Name",
      accessor: "sourceName",
      width: 250
    },
    {
      Header: "OP Date",
      accessor: (d) => {
        return d.opDate !== true ? convertTimeStampToDate(d.opDate) : "";
      },
      width: 75
    },
    {
      Header: "Status",
      accessor: (d) => {
        return d.status ? waterSystemStatus[d.status] : "";
      },
      width: 80
    },
    {
      Header: "Reason",
      accessor: (d) => {
        return d.statusReason ? activityType[d.statusReason] : "";
      },
      width: 250
    },
    {
      Header: "Source Type",
      accessor: (d) => {
        return d.sourceType ? sourceType[d.sourceType] : "";
      },
      width: 100
    },
    {
      Header: "Water Type",
      accessor: (d) => {
        return d.waterType ? waterType[d.waterType] : "";
      }
    },
    {
      Header: "Period of Op",
      accessor: (d) => {
        return d.status === "A" && d.startMonth && d.startDay
          ? d.startMonth + "/" + d.startDay + " - " + d.endMonth + "/" + d.endDay
          : "";
      }
    }
  ];

  const details = React.useMemo(
    () => [
      {
        Header: "Flow",
        accessor: "flow"
      },
      {
        Header: "Flow Rate",
        accessor: "flowRate"
      },
      {
        Header: "UOM",
        accessor: "flowUom"
      }
    ],
    []
  );

  const { loading, error, data } = useQuery(GET_SOURCES, {
    variables: { systemId }
  });

  const subTable = React.useCallback(
    ({ row }) =>
      row.original.flows.length > 0 ? (
        <DtsReactTable columns={details} data={row.original.flows} headerColor='grey' />
      ) : (
        "No Data"
      ),
    [details]
  );

  const expandedRows = React.useMemo(() => {
    if (data) {
      let arr = {};
      let d = data;
      if (d.getSourcesBySystemId.length > 0) {
        d.getSourcesBySystemId.forEach(function (elem, index) {
          if (elem.flows.length > 0) {
            arr[index] = true;
          }
        });
      }
      return arr;
    }
  }, [data]);

  let totalSources = 0;

  if (loading) {
    return <SkeletonLoader width='100%' />;
  } else if (error) {
    return <ErrorHandler error={error} />;
  } else {
    let sourcesArray = data.getSourcesBySystemId;

    totalSources = sourcesArray.length;
  }

  return (
    <>
      <DtsReactTable
        data={data.getSourcesBySystemId}
        columns={columns}
        headerColor='ddw'
        renderRowSubComponent={subTable}
        expandRows={true}
        expandedRowObj={expandedRows}
        subTableId='_sourceSubTable'
      />
      <h5>Total Sources: {totalSources}</h5>
    </>
  );
};

export default SourcesTable;
